import React, { useContext, useEffect, useRef, useState } from "react";
import "../css/layout.css";
import css from "../Modulecss/Home.module.css";
import axios from "axios";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import { useDispatch } from "react-redux";
import BetCard from "./BetCard";
import RunningCard from "./RunningCard";
import Header from "../Components/Header";
import io from "../Components/socket";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import guidebutton from "../../assets/images/guidebutton.png";
import socket from "../Components/socket";
import acceptSound from "./accept.mp3";
import findGif from "../css/loading_old.gif";
import playSound from "./accept.mp3";
import { MdOutlineDelete } from "react-icons/md";
import { FiRefreshCcw } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import FakeRunningBattle from "./FakeRunningBattle";

export default function Homepage({ rungame, homePlay, users }) {
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const history = useHistory();
  let userID = useRef();
  const isMounted = useRef(true);
  let str;

  const [user, setUser] = useState();
  const [create, setCreated] = useState([]);
  const [challangeReqRun, setChallangeReqRun] = useState(false);

  const [game_amount, setGame_amt] = useState();

  const [gameData, setGameData] = useState({});

  const [submitProcess, setProcess] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  const userId = localStorage.getItem("userId");
  const access_token = localStorage.getItem("token");
  const [disable, setDisable] = React.useState(challangeReqRun);
  const [disable_play, setDisable_play] = React.useState(false);
  const [GameList, setGameList] = useState(homePlay);

  const req_chall_fun = (allgameId) => {
    getPost(allgameId);
  };

  const disablebtn = (id) => {
    setDisable(true);
    setTimeout(() => {
      setDisable(false);
    }, 10000);
    //  sendMessage()
  };

  const disable_play_btn = () => {
    setDisable_play(true);
    setTimeout(() => {
      setDisable_play(false);
    }, 3000);
    // status_fun()
  };

  /// user details end

  const [game_type, setGame_type] = useState(
    useLocation().pathname.split("/")[2]
  );
  const [game_type2, setGame_type2] = useState(
    useLocation().pathname.split("/")[3]
  );
  const [Game_Ammount, setGame_Ammount] = useState("");

  const ChallengeCreate = async (e) => {
    setIsloading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (game_type == "ludoClassicManual") {
      if (Game_Ammount >= 50 && Game_Ammount <= 50000) {

        try {
          const res = await apiRequest(`challange/create`, "POST", { Game_Ammount, Game_type: game_type, }, headers)
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({
              title: "You have already enrolled",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({
              title: "You can set maximum 2 battle.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({
              title: "Insufficient balance",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (
            res.data.msg ===
            "Game amount should be Greater then 50 and less then 50000"
          ) {
            setIsloading(false);
            Swal.fire({
              title:
                "Game amount should be Greater then 50 and less then 50000",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({
              title: "Set Battle in denomination of 50",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({
              title: "Technical Issue, Try after an hour!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            setIsloading(false);
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("token");
            window.location.reload();
            setTimeout(() => {
              //  history.push("/login")
            }, 500);
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
          console.log(e);
        }
      } else {
        setIsloading(false);
        Swal.fire({
          title: "Please Amount should be greater 50 and less 50000!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else if (game_type == "ludoClassicRich") {
      if (Game_Ammount >= 550 && Game_Ammount <= 200000) {

        try {
          const res = await apiRequest(`challange/create`, "POST", { Game_Ammount, Game_type: game_type, }, headers)
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({
              title: "You have already enrolled",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({
              title: "You can set maximum 2 battle.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({
              title: "Insufficient balance",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (
            res.data.msg ===
            "Game amount should be Greater then 50 and less then 50000"
          ) {
            setIsloading(false);
            Swal.fire({
              title:
                "Game amount should be Greater then 50 and less then 50000",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({
              title: "Set Battle in denomination of 50",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({
              title: "Technical Issue, Try after an hour!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            setIsloading(false);
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("token");
            window.location.reload();
            setTimeout(() => {
              //  history.push("/login")
            }, 500);
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
          console.log(e);
        }

      } else {
        setIsloading(false);
        Swal.fire({
          title: "Please Amount should be greater 550 and less 200000!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else {
      try {
        const res = await apiRequest(`challange/create`, "POST", { Game_Ammount, Game_type: game_type }, headers)

        setGame_amt(res?.data?.data?.Game_Ammount);

        if (res.data.status == false) {
          setIsloading(false);
          Swal.fire({
            title: res.data.msg,
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "you have already enrolled") {
          setIsloading(false);
          Swal.fire({
            title: "You have already enrolled",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "You can set maximum 2 battle.") {
          setIsloading(false);
          Swal.fire({
            title: "You can set maximum 2 battle.",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Insufficient balance") {
          setIsloading(false);
          Swal.fire({
            title: "Insufficient balance",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (
          res.data.msg ===
          "Game amount should be Greater then 50 and less then 50000"
        ) {
          setIsloading(false);
          Swal.fire({
            title:
              "Game amount should be Greater then 50 and less then 50000",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Set Battle in denomination of 50") {
          setIsloading(false);
          Swal.fire({
            title: "Set Battle in denomination of 50",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Technical Issue, Try after an hour!") {
          setIsloading(false);
          Swal.fire({
            title: "Technical Issue, Try after an hour!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else {
          setIsloading(false);
        }
      } catch (e) {

        setIsloading(false);
        if (e?.response?.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
          setTimeout(() => {
            //  history.push("/login")
          }, 500);
        }
        if (e?.response?.status == 400 || e?.response?.status == 429) {
          Swal.fire({
            title: "Please refresh!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
        console.log(e);
        // });
      }
    }
  };

  //open bat

  const [MyopenBattle, setMyOpenBattle] = useState([]);
  const [OtheropenBattle, setOtherMyOpenBattle] = useState([]);
  const [MyrunningBattle, setMyRunningBattle] = useState([]);
  const [OtherrunningBattle, setOtherRunningBattle] = useState([]);

  useEffect(() => {
    socket.emit("getgamelist", userId);
    socket.on("setGamelist", (data) => {
      setGameList(data);
    });
  }, []);

  useEffect(() => {
    io.on("gameCreate", (data) => {
      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });
    io.on("deletebat", (data) => {
      // Log the _id values in the MyopenBattle array
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item._id !== data
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item._id !== data
        );
        return updatedOtheropenBattle;
      });
    });

    io.on("gameUpdate", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item?._id !== data?._id
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item?._id !== data?._id
        );
        return updatedOtheropenBattle;
      });
      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });

    io.on("startAccepted", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item?._id !== data?._id
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item?._id !== data?._id
        );
        return updatedOtheropenBattle;
      });

      if (data.Status === "running" && data?.Created_by?._id === userId) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      } else if (
        data.Status === "running" &&
        data?.Accepetd_By?._id === userId
      ) {
        if (!MyopenBattle?.some((item) => item?._id === data?._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtherrunningBattle?.some((item) => item?._id === data?._id)) {
          setOtherRunningBattle((OtherrunningBattle) => [
            data,
            ...OtherrunningBattle,
          ]);
        }
      }
    });

    io.on("acceptor_seen_game", (data) => {
      // debugger
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item?._id !== data?._id
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle?.filter(
          (item) => item?._id !== data?._id
        );
        return updatedOtheropenBattle;
      });

      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
    io.on("challangeAccept", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item._id !== data._id
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle?.filter(
          (item) => item?._id !== data?._id
        );
        return updatedOtheropenBattle;
      });

      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
  }, [io]);

  function winnAmount(gameAmount) {
    let profit = null;
    // {console.log(addCaseSetting?.commissionRange2)}
    if (gameAmount >= 50 && gameAmount <= 250)
      profit = (gameAmount * addCaseSetting?.commissionRange1) / 100;
    else if (gameAmount > 250 && gameAmount <= 500)
      profit = addCaseSetting?.commissionRange2;
    else if (gameAmount > 500)
      profit = (gameAmount * addCaseSetting?.commissionRange3) / 100;
    return gameAmount - profit;
  }

  useEffect(() => {
    // walletUpdate();
    let owenedCreated = [];
    let remainingGame = [];

    GameList?.openBattle?.forEach(function (ele) {
      if (ele)
        if (
          (ele?.Created_by?._id == userId || ele?.Accepetd_By?._id == userId) &&
          (ele?.Status == "new" || ele?.Status == "requested")
        ) {
          owenedCreated.push(ele);
        } else if (ele?.Status == "new") {
          remainingGame.push(ele);
        } else if (
          ele?.Status == "running" &&
          ele?.Accepetd_By?._id == userId &&
          ele?.Acceptor_seen === false
        ) {
          owenedCreated.push(ele);
        }
    });
    setMyOpenBattle(owenedCreated);
    setOtherMyOpenBattle(remainingGame);
    let owenedRunning = [];
    let remainingRunning = [];
    GameList?.runningBattle?.forEach(function (ele) {
      if (ele.Created_by && ele.Accepetd_By)
        if (ele.Created_by?._id == userId || ele.Accepetd_By?._id == userId) {
          owenedRunning.push(ele);
        } else {
          remainingRunning.push(ele);
        }
    });
    setMyRunningBattle(owenedRunning);

    setOtherRunningBattle(remainingRunning);
    // walletUpdate();
  }, [GameList]);

  useEffect(() => {
    io.on("resultUpdateReq1", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item?._id !== data?._id
        );
        return updatedMyOpenBattle;
      });

      if (data.Status === "cancelled" || data.Status === "completed") {
        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id
          );
          return updatedowenedRunning;
        });
        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id
          );
          return updatedrunningGames;
        });
      } else {
        // Check if the user's ID matches Created_by or Accepted_By
        const isUserOwned =
          data?.Created_by?._id === userId || data?.Accepetd_By?._id === userId;

        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id
          );
          if (isUserOwned) {
            updatedowenedRunning.push(data);
          }
          return updatedowenedRunning;
        });

        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id
          );
          if (!isUserOwned) {
            updatedrunningGames.push(data);
          }
          return updatedrunningGames;
        });
      }
    });
  }, [io, userId]);

  // useEffect(() => {
  //   io.on("resultUpdateReq1", (data) => {
  //     setMyOpenBattle((MyopenBattle) => {
  //       const updatedMyOpenBattle = MyopenBattle?.filter(
  //         (item) => item?._id !== data?._id
  //       );
  //       return updatedMyOpenBattle;
  //     });
  //     let owenedRunning = [];
  //     let remainingRunning = [];
  //     if (data.Status == "cancelled" || data.Status == "completed") {
  //       setMyRunningBattle((MyrunningBattle) => {
  //         const updatedowenedRunning = MyrunningBattle?.filter(
  //           (item) => item?._id !== data?._id
  //         );
  //         return updatedowenedRunning;
  //       });
  //       setOtherRunningBattle((OtherrunningBattle) => {
  //         const updatedrunningGames = OtherrunningBattle?.filter(
  //           (item) => item?._id !== data?._id
  //         );
  //         return updatedrunningGames;
  //       });
  //     } else {
  //       if (data?.Created_by && data?.Accepetd_By)
  //         if (
  //           data?.Created_by?._id == userId ||
  //           data?.Accepetd_By?._id == userId
  //         ) {
  //           owenedRunning.push(data);
  //         } else {
  //           remainingRunning.push(data);
  //         }
  //       // });
  //       setMyRunningBattle(owenedRunning);
  //       setOtherRunningBattle(remainingRunning);
  //     }
  //   });
  // }, [io]);

  useEffect(() => {
    let access_token = localStorage.getItem("token");
    access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
      setTimeout(() => { }, 500);
    }

    return () => {
      // role();
    };
  }, []);

  const RunningGames = async () => {
    const access_tokena = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`challange/running/all`, "GET", null, headers)
      // setRunGames(res.data)
      let owenedRunning = [];
      let remainingRunning = [];
      res?.data?.forEach(function (ele) {
        if (ele.Created_by && ele.Accepetd_By)
          if (
            ele.Created_by?._id == userId ||
            ele.Accepetd_By?._id == userId
          ) {
            owenedRunning.push(ele);
          } else {
            remainingRunning.push(ele);
          }
      });
      setMyRunningBattle(owenedRunning);
      setOtherRunningBattle(remainingRunning);

    } catch (e) {
      console.log("errror", e);
    }


    // .then((res) => {

    // })
    // .catch((e) => {
    //   console.log("errror", e);
    // });
  };

  //accept Challange

  const AcceptChallang = async (id) => {
    if (str == 1) {
      Swal.fire({
        title: "Other request in process",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
    str = 1;
    const access_token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`challange/accept/${id}`, "PUT", { Accepetd_By: headers, Acceptor_by_Creator_at: Date.now() }, headers)
      setGameData({
        accept_by: res.data.Accepetd_By,
        created_by: res.data.Created_by,
      });

      str = 0;
      if (res.data.status === false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "you have already enrolled") {
        Swal.fire({
          title: "You have already enrolled",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "Insufficient balance") {
        Swal.fire({
          title: "Insufficient balance",
          icon: "warning",
          confirmButtonText: "OK",
        });
      } if (res.data.msg === "Game already start with other player") {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      console.log(e);
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => { }, 500);
      }
      if (e.response.status == 400) {
        Swal.fire({
          title: e.response.data,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  //reject Game
  const RejectGame = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`challange/reject/${id}`, "PUT", { Accepetd_By: null, Status: "new", Acceptor_by_Creator_at: null, }, headers)
      if (res) {
        // io.emit("gameRejected");
      }
    } catch (e) {
      console.log(e);
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")
        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  //delete

  const deleteChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`challange/delete/${_id}`, "DELETE", null, headers)
      if (res.data.status == false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      if (e?.response?.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")
        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };


  ///challange/running/update/

  const updateChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`challange/running/update/${_id}`, "PUT", { Acceptor_seen: true, }, headers)
      if (res) {
        localStorage.setItem("timeOver", "timeStart");
        // io.emit("game_seen");
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")
        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      console.log(e);
    }
  };


  const getPost = async (Id) => {
    if (
      game_type === "Ludo Classics" ||
      game_type === "Ludo 1 Goti" ||
      game_type === "Ludo Ulta" ||
      game_type === "Prime Ludo" ||
      game_type === "Ludo Host"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);

        const access_token = localStorage.getItem("token");

        const headers = {
          authorization: `Bearer ${access_token}`,
        };

        try {
          const res = await apiRequest(`challange/requested/running/${game_type}/` + Id, "PATCH", null, headers)
          setProcess(true);
          setChallangeReqRun(false);
          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            history.push(`/viewgame1/${Id}`, {
              prevPath: window.location?.pathname,
            });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({
              title: "Somthing wrong",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }


      }
    } else if (
      game_type === "LudoSnake" ||
      game_type === "LudoPopular" ||
      game_type === "ludoClassicManual" ||
      game_type === "ludoClassicRich"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);

        const access_token = localStorage.getItem("token");

        const headers = {
          authorization: `Bearer ${access_token}`,
        };

        try {
          const res = await apiRequest("challange/requested/running/" + Id, "PATCH", {}, headers)
          setProcess(true);
          setChallangeReqRun(false);

          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            history.push(`/viewgame1/${Id}`, {
              prevPath: window.location?.pathname,
            });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({
              title: "Somthing wrong",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      }
    }
  };

  const handleButtonClick = (gameType) => {
    setGame_type(gameType);
  };
  // Socket for GameModeChange list

  const GameModeChange = () => {
    socket.on("setGamelist", (modeData) => {
      setGameList(modeData);
    });
  };
  useEffect(() => {
    // RunningGames()
  }, [])

  // language 
  const translations = {
    hi: {
      gameadd: 'गेम बनाये !',
      gameset: 'लगाये',
      openGame: 'खुला गेम ',
      challange: 'चुनोती देने वाला  ',
      entry: 'प्रवेश शुल्क',
      prize: 'इनाम',
      play: 'खेले ',
      running: 'चल रहे गेम ',
      start: 'चालू',
      cancel: 'रद्द करें',
    },
    en: {
      gameadd: 'Create a Battle!',
      gameset: 'Set',
      openGame: 'Open Battles',
      challange: 'Challange From  ',
      entry: 'Entry Fee ',
      prize: 'winning Prize  ',
      play: 'Play',
      running: 'Running Battles',
      start: 'Start',
      cancel: 'Decline',
    },
  };

  const { language } = useContext(LanguageContext);


  // change theme 
  // change theme
  // const theme1 = localStorage.getItem("theme");
  // let theme = "";
  // if (theme1 == "dark") {
  //   theme = "light";
  // } else {
  //   theme = "dark";
  // }
  const theme = localStorage.getItem("theme")
  const styles = {
    backgroundColor: theme === 'light' ? '#000' : 'black',
    color: theme === 'light' ? 'black' : '#fff',
  };
  const styles1 = {
    backgroundColor: theme === 'light' ? '#000' : 'green',
    color: theme === 'light' ? 'black' : '#fff',
  };
  const styles3 = {
    backgroundColor: theme === 'light' ? 'rgb(38, 53, 93)' : '#27241b',
    color: theme === 'light' ? '#fff' : '#fff',
  };

  const backgroundColor = theme === 'light' ? '#fff' : '#333 !important';

  // =======fake open battle==============

  const [fakeBattles, setFakeBattles] = useState([]);
  const ranges = [
    [500, 1500],
    [3000, 7000],
    [11000, 15000],
    [20000, 30000],
  ];

  const indianNames = [
    "Aman",
    "Rahul",
    "Rohit",
    "Vikas",
    "Ankit",
    "Neha",
    "Pooja",
    "Riya",
    "Priya",
    "Deepak",
    "Mohit",
    "Karan",
    "Ajay",
    "Sonu",
    "Monu"
  ];

  const attitudeNames = [
    "King",
    "Jaat",
    "Mahakal",
    "Badshah",
    "Legend",
    "Danger",
    "Boss",
    "Sarkar",
    "Don",
    "Royal",
    "Sher",
    "Alpha"
  ];

  const emojis = [
    "🔥",
    "😎",
    "👑",
    "🌹",
    "❤️",
    "💀",
    "⚡",
    "🚩",
    "🦁",
    "💎"
  ];
  const generateRandomString = () => {

    const chars =
      "abcdefghijklmnopqrstuvwxyz";

    const len =
      Math.floor(Math.random() * 4) + 5;

    let str = "";

    for (let i = 0; i < len; i++) {
      str += chars[
        Math.floor(Math.random() * chars.length)
      ];
    }

    return str;
  };

  const getRandomName = () => {

    const rand = Math.random();

    // 40% indian names
    // if (rand < 0.40) {

    //   return indianNames[
    //     Math.floor(Math.random() * indianNames.length)
    //   ];
    // }

    // 25% random letters
    if (rand < 0.65) {

      return generateRandomString();
    }

    // 20% attitude names
    if (rand < 0.85) {

      return attitudeNames[
        Math.floor(Math.random() * attitudeNames.length)
      ];
    }

    // 10% name + emoji
    if (rand < 0.95) {

      const name =
        attitudeNames[
        Math.floor(Math.random() * attitudeNames.length)
        ];

      const emoji =
        emojis[
        Math.floor(Math.random() * emojis.length)
        ];

      return `${name}${emoji}`;
    }

    // 5% emoji only
    return emojis[
      Math.floor(Math.random() * emojis.length)
    ];
  };

  const lastHighBattleRef = useRef(0);

  const getRandomAmount = () => {

    const now = Date.now();

    let rand = Math.random();

    // 20k-30k battle har 20 sec se pehle nahi
    if (
      now - lastHighBattleRef.current < 20000
    ) {

      rand = Math.random() * 0.95;
    }

    let min;
    let max;

    if (rand < 0.55) {
      min = 500;
      max = 1500;
    }
    else if (rand < 0.85) {
      min = 3000;
      max = 7000;
    }
    else if (rand < 0.97) {
      min = 11000;
      max = 15000;
    }
    else {

      min = 20000;
      max = 30000;

      lastHighBattleRef.current = now;
    }

    const steps =
      Math.floor((max - min) / 50);

    return (
      min +
      Math.floor(Math.random() * (steps + 1)) * 50
    );
  };
  const countOptions = [0, 1, 1, 2, 2, 2, 3, 3, 4];

  const targetCount =
    countOptions[
    Math.floor(Math.random() * countOptions.length)
    ];

  // const lastHighBattleRef = useRef(0);
  const now = Date.now();

  const allowHighBattle =
    now - lastHighBattleRef.current > 15000;

  const createBattleBatch = () => {

    const batchSize =
      [1, 1, 1, 2, 2, 3][
      Math.floor(Math.random() * 6)
      ];

    const battles = [];

    for (let i = 0; i < batchSize; i++) {

      battles.push({
        _id: `fake_${Date.now()}_${Math.random()}`,
        Game_Ammount: getRandomAmount(),
        Status: "new",
        requestedByUser: false,
        Created_by: {
          _id: "bot",
          Name: getRandomName()
        },
      });
    }

    setFakeBattles(prev => {

      const updated = [...battles, ...prev];

      return updated.slice(0, 4);
    });
  };

  // auto generate
  useEffect(() => {

    createBattleBatch();

    const addInterval = setInterval(() => {

      createBattleBatch();

    }, 6000 + Math.random() * 4000);
    // 6-10 sec

    const removeInterval = setInterval(() => {

      removeRandomBattle();

    }, 4000 + Math.random() * 5000);
    // 4-9 sec

    return () => {

      clearInterval(addInterval);
      clearInterval(removeInterval);

    };

  }, []);


  const handleFakePlay = (battle) => {

    const walletAmount = Number(users?.Wallet_balance || 0);

    if (walletAmount < battle.Game_Ammount) {
      Swal.fire({
        title: "Insufficient Balance",
        icon: "warning",
      });
      return;
    }

    setFakeBattles(prev =>
      prev.map(item =>
        item._id === battle._id
          ? {
            ...item,
            Status: "requested",
            requestedByUser: true,
          }
          : item
      )
    );
  };

  const handleFakeCancel = (battleId) => {

    setFakeBattles(prev =>
      prev.map(item =>
        item._id === battleId
          ? {
            ...item,
            Status: "new",
            requestedByUser: false,
          }
          : item
      )
    );

  };

  const removeRandomBattle = () => {

    setFakeBattles(prev => {

      if (prev.length === 0) return prev;

      const randomIndex =
        Math.floor(Math.random() * prev.length);

      return prev.filter(
        (_, index) => index !== randomIndex
      );
    });

  };


  return (
    <>
      {/* <Header user={users} /> */}
      <div
        className="leftContainer  "
        style={styles}
      >
        <div className="Orher_page_main_section" >

          {(() => {
            const sitSettingRaw = localStorage.getItem("sitSetting");

            if (!sitSettingRaw || sitSettingRaw === "undefined") return null;

            const sitSetting = JSON.parse(sitSettingRaw);
            const manualMsg = sitSetting?.ludoClassicManualMsg;
            const autoMsg = sitSetting?.ludoClassicAutoMsg;

            const showMessage = game_type === "LudoSnake" ? manualMsg : autoMsg;

            if (!showMessage) return null;

            return (


              <div className="rk_notice_card">

                <div className="rk_notice_icon">
                  ⭐
                </div>

                <div className="rk_notice_content">
                  <span className="rk_notice_label">
                    NOTICE
                  </span>

                  <h5 className="rk_notice_text">
                    {showMessage}  </h5>
                </div>

                <div className="rk_notice_spark">
                  ✦
                </div>

              </div>
            );
          })()}




          <div>
            {/* =========================================================
    CREATE A BATTLE
========================================================= */}

            {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
              ""
            ) : JSON.parse(localStorage.getItem("sitSetting"))?.gameSearch == true ? (
              <div className="prince_battle_card">



                <div className="prince_battle_header">

                  <div className="prince_battle_title_wrap">

                    <div className="prince_battle_icon">
                      ⚔
                    </div>

                    <div className="prince_battle_heading_content">

                      <span className="prince_battle_eyebrow">
                        PRINCE LUDO
                      </span>

                      <span className="prince_battle_title">
                        Create a Battle!
                      </span>

                      <span className="prince_battle_subtitle">
                        Set your battle amount and start playing
                      </span>

                    </div>

                  </div>


                  {/* RULES */}

                  <NavLink
                    to="/Rules"
                    className="prince_battle_rules"
                  >

                    <span>
                      Rules
                    </span>

                    <span className="prince_rules_icon">
                      ?
                    </span>

                  </NavLink>

                </div>


                {/* =========================================
        AMOUNT BOX
    ========================================= */}

                <div className="prince_create_input_area">

                  <div className="prince_create_input_wrap">

                    <span className="prince_create_currency">
                      ₹
                    </span>

                    <input
                      className="prince_create_amount_input"
                      type="number"
                      placeholder="Enter amount"
                      value={Game_Ammount}
                      onChange={(e) => setGame_Ammount(e.target.value)}
                    />

                  </div>

                  {!isLoading ? (

                    <button
                      type="button"
                      className="prince_create_set_btn"
                      onClick={(e) => {
                        e.preventDefault();
                        setGame_Ammount("");
                        ChallengeCreate();
                      }}
                    >
                      <span className="prince_create_set_icon">
                        ⚔
                      </span>

                      <strong>
                        Set
                      </strong>
                    </button>

                  ) : (

                    <button
                      type="button"
                      className="prince_create_set_btn prince_create_loading_btn"
                      disabled
                    >
                      <span className="prince_create_loader"></span>

                      <strong>
                        Loading...
                      </strong>
                    </button>

                  )}

                </div>
              </div>
            ) : (
              ""
            )}


            <div className="">
              <div className="prince_open_battle_heading">

                <div className="prince_heading_side prince_heading_left">
                  <span></span>
                  <b>✦</b>
                  <span></span>
                </div>


                <div className="prince_open_battle_text">

                  <small>PRINCE LUDO</small>

                  <h2>
                    {translations[language].openGame}
                  </h2>

                </div>


                <div className="prince_heading_side prince_heading_right">

                  <span></span>
                  <b>✦</b>
                  <span></span>

                </div>

              </div>



              {MyopenBattle &&

                MyopenBattle
                  .filter((allgame) => allgame?.Game_type === game_type)
                  .map((allgame, index) => (
                    <div className="prince_open_game_card  prince_self_open_game_card premium_battle_layout">

                      {/* =====================================================
      LEFT TROPHY
  ====================================================== */}

                      <div className="prince_game_trophy_area">

                        <div className="prince_trophy_glow"></div>

                        <img
                          src="../images/tiger.png"
                          className="prince_game_trophy"
                          alt=""
                        />

                      </div>


                      {/* =====================================================
      CENTER GAME INFORMATION
  ====================================================== */}

                      <div className="prince_game_info">

                        {/* PLAYER + LIVE */}

                        <div className="prince_game_player">

                          <span className="prince_live_badge">

                            <span className="prince_live_icon"></span>

                            <span className="prince_live_text">
                              Live
                            </span>

                          </span>

                          <span className="prince_player_name">

                            {allgame?.Created_by?.Name?.slice(0, 5)}

                            {allgame?.Created_by?.Name?.length > 5 && "..."}

                          </span>

                        </div>


                        {/* =================================================
        AMOUNTS
    ================================================== */}

                        <div className="prince_game_amount_box">

                          {/* ENTRY FEE */}

                          <div className="prince_game_amount">

                            <span className="prince_amount_label">
                              ENTRY FEE
                            </span>

                            <strong className="prince_entry_amount">
                              ₹{allgame?.Game_Ammount}
                            </strong>

                          </div>


                          {/* WINNING PRIZE */}

                          <div className="prince_game_amount">

                            <span className="prince_amount_label">
                              WINNING PRIZE
                            </span>

                            <strong className="prince_winning_amount">
                              ₹
                              {
                                allgame?.Game_Ammount +
                                winnAmount(allgame?.Game_Ammount)
                              }
                            </strong>

                          </div>

                        </div>

                      </div>


                      {/* =====================================================
      RIGHT ACTIONS
  ====================================================== */}

                      <div className="prince_game_action">


                        {/* =================================================
        CREATOR WAITING - NEW
    ================================================== */}

                        {userId == allgame?.Created_by?._id &&
                          allgame?.Status == "new" && (

                            <div className="prince_game_loader">

                              <img
                                src="/images/LandingPage_img/loader1.gif"
                                alt=""
                              />

                            </div>

                          )}


                        {/* =================================================
        PLAY
    ================================================== */}

                        {userId &&
                          allgame &&
                          userId !== allgame?.Created_by?._id &&
                          allgame?.Status == "new" && (

                            <button
                              type="button"
                              className="prince_play_btn"
                              disabled={disable_play}
                              onClick={() => {

                                disable_play_btn();

                                AcceptChallang(allgame?._id);

                              }}
                            >

                              <span className="prince_play_text">
                                PLAY
                              </span>

                              <span className="prince_play_arrow">
                                ▶
                              </span>

                            </button>

                          )}


                        {/* =================================================
        DELETE - CREATOR
    ================================================== */}

                        {userId == allgame?.Created_by?._id &&
                          allgame?.Status == "new" && (

                            <button
                              type="button"
                              className="prince_play_btn prince_start_btn prince_cancel_btn"
                              onClick={() =>
                                deleteChallenge(allgame?._id)
                              }
                            >
                              <span className="prince_play_text">
                                DELETE
                              </span>

                            </button>

                          )}


                        {/* =================================================
        REQUESTED - OTHER USER
    ================================================== */}

                        {userId !== allgame?.Created_by?._id &&
                          allgame?.Status == "requested" && (

                            <div className="prince_requested_wrap">

                              <button
                                type="button"
                                className="prince_play_btn prince_start_btn prince_requested_btn"
                              >

                                {/* <span className="prince_requested_dot"></span> */}

                                <span className="prince_play_text">
                                  Requested
                                </span>

                              </button>


                              <button
                                type="button"
                                className="prince_play_btn prince_start_btn prince_cancel_btn mr-2"
                                onClick={() =>
                                  RejectGame(allgame?._id)
                                }
                              >
                                <span className="prince_play_text">
                                  CANCEL
                                </span>
                              </button>

                            </div>

                          )}


                        {/* =================================================
        RUNNING - OTHER USER
    ================================================== */}

                        {userId &&
                          allgame &&
                          userId !== allgame?.Created_by?._id &&
                          allgame?.Status == "running" && (

                            <>

                              <audio
                                src={playSound}
                                autoPlay
                              ></audio>


                              <button
                                type="button"
                                className="prince_play_btn prince_start_btn"
                                disabled={disable}
                                onClick={() => {

                                  disablebtn();

                                  updateChallenge(allgame?._id);

                                  history.push(
                                    `/viewgame1/${allgame?._id}`,
                                    {
                                      prevPath:
                                        window.location.pathname,
                                    }
                                  );

                                }}
                              >

                                <span className="prince_play_text">
                                  START
                                </span>

                                <span className="prince_play_arrow">
                                  ▶
                                </span>

                              </button>

                            </>

                          )}


                        {/* =================================================
        CREATOR - REQUEST ACCEPTED
    ================================================== */}

                        {userId == allgame?.Created_by?._id &&
                          allgame?.Status == "requested" && (

                            <div className="prince_creator_actions">

                              <audio
                                src={acceptSound}
                                autoPlay
                              ></audio>


                              {/* START */}

                              <button
                                type="button"
                                disabled={disable}
                                className="prince_play_btn prince_start_btn"
                                style={{
                                  display: disable
                                    ? "none"
                                    : "flex",
                                }}
                                onClick={() => {

                                  disablebtn(allgame?._id);

                                  req_chall_fun(allgame?._id);

                                }}
                              >

                                <span className="prince_play_text">
                                  START
                                </span>

                                <span className="prince_play_arrow">
                                  ▶
                                </span>

                              </button>


                              {/* WAIT */}

                              <button
                                type="button"
                                className={
                                  disable
                                    ? "prince_play_btn prince_start_btn prince_wait_btn"
                                    : "d-none"
                                }
                              >
                                WAIT
                              </button>


                              {/* CANCEL */}

                              <button
                                type="button"
                                className={
                                  disable
                                    ? "d-none"
                                    : "prince_play_btn prince_start_btn prince_cancel_btn"
                                }
                                onClick={() =>
                                  RejectGame(allgame?._id)
                                }
                              >
                                <span className="prince_play_text">
                                  CANCEL
                                </span>
                              </button>

                            </div>

                          )}

                      </div>

                    </div>
                  ))}

              {OtheropenBattle &&
                OtheropenBattle?.filter(
                  (allgame) => allgame?.Game_type === game_type
                ).map((allgame, index) => (
                  <div className="prince_open_game_card premium_battle_layout">

                    {/* =====================================================
      LEFT TROPHY
  ====================================================== */}

                    <div className="prince_game_trophy_area">

                      <div className="prince_trophy_glow"></div>

                      <img
                        src="../images/tiger.png"
                        className="prince_game_trophy"
                        alt=""
                      />

                    </div>


                    {/* =====================================================
      CENTER GAME INFORMATION
  ====================================================== */}

                    <div className="prince_game_info">

                      {/* PLAYER NAME + LIVE */}

                      <div className="prince_game_player">

                        <span className="prince_live_badge">

                          <span className="prince_live_icon"></span>

                          <span className="prince_live_text">
                            Live
                          </span>

                        </span>


                        <span className="prince_player_name">

                          {allgame?.Created_by?.Name?.slice(0, 5)}

                          {allgame?.Created_by?.Name?.length > 5 && "..."}

                        </span>

                      </div>


                      {/* =================================================
        AMOUNT INFORMATION
    ================================================== */}

                      <div className="prince_game_amount_box">

                        {/* ENTRY FEE */}

                        <div className="prince_game_amount">

                          <span className="prince_amount_label">
                            ENTRY FEE
                          </span>

                          <strong className="prince_entry_amount">
                            ₹{allgame?.Game_Ammount}
                          </strong>

                        </div>


                        {/* DIVIDER */}

                        {/* <div className="prince_amount_divider"></div> */}


                        {/* WINNING PRIZE */}

                        <div className="prince_game_amount">

                          <span className="prince_amount_label">
                            WINNING PRIZE
                          </span>

                          <strong className="prince_winning_amount">
                            ₹
                            {
                              allgame?.Game_Ammount +
                              winnAmount(allgame?.Game_Ammount)
                            }
                          </strong>

                        </div>

                      </div>

                    </div>


                    {/* =====================================================
      RIGHT ACTIONS
  ====================================================== */}

                    <div className="prince_game_action">


                      {/* =================================================
        PLAY BUTTON
    ================================================== */}

                      {userId &&
                        allgame &&
                        userId !== allgame?.Created_by?._id &&
                        allgame?.Status == "new" && (

                          <button
                            type="button"
                            className="prince_play_btn"
                            disabled={disable_play}
                            onClick={() => {

                              disable_play_btn();

                              AcceptChallang(allgame?._id);

                            }}
                          >

                            <span className="prince_play_text">
                              PLAY
                            </span>

                            <span className="prince_play_arrow">
                              ▶
                            </span>

                          </button>

                        )}


                      {/* =================================================
        CREATOR LOADING
    ================================================== */}

                      {userId == allgame?.Created_by?._id &&
                        allgame?.Status == "new" && (

                          <div className="prince_game_loader">

                            <img
                              src="/images/LandingPage_img/loader1.gif"
                              alt=""
                            />

                          </div>

                        )}


                      {/* =================================================
        REQUESTED + CANCEL
    ================================================== */}

                      {userId !== allgame?.Created_by?._id &&
                        allgame?.Status == "requested" && (

                          <div className="prince_requested_wrap">

                            <div className="prince_requested_btn">

                              <span className="prince_requested_dot"></span>

                              <span>
                                Requested
                              </span>

                            </div>


                            <button
                              type="button"
                              className="prince_cancel_btn"
                              onClick={() =>
                                RejectGame(allgame?._id)
                              }
                            >
                              Cancel
                            </button>

                          </div>

                        )}


                      {/* =================================================
        START BUTTON
    ================================================== */}

                      {userId &&
                        userId !== allgame?.Created_by?._id &&
                        allgame?.Status == "running" && (

                          <button
                            type="button"
                            className="prince_play_btn prince_start_btn"
                            disabled={disable}
                            onClick={(e) => {

                              disablebtn();

                              updateChallenge(allgame?._id);

                              history.push(
                                `/viewgame1/${allgame?._id}`,
                                {
                                  prevPath:
                                    window.location.pathname,
                                }
                              );

                            }}
                          >

                            <span className="prince_play_text">
                              START
                            </span>

                            <span className="prince_play_arrow">
                              ▶
                            </span>

                          </button>

                        )}

                    </div>

                  </div>
                ))}
            </div>


            {/* ====open fake battle===== */}
            {
              addCaseSetting?.openBotOnOff && fakeBattles.map((allgame) => (

                <div
                  className={`prince_open_game_card premium_battle_layout ${allgame.leaving ? "battle_exit" : ""
                    }`}
                  key={allgame._id}
                >

                  {/* =====================================================
      LEFT TROPHY
  ====================================================== */}

                  <div className="prince_game_trophy_area">

                    <div className="prince_trophy_glow"></div>

                    <img
                      src="../images/tiger.png"
                      className="prince_game_trophy"
                      alt=""
                    />

                  </div>


                  {/* =====================================================
      CENTER GAME INFORMATION
  ====================================================== */}

                  <div className="prince_game_info">

                    {/* PLAYER + LIVE */}

                    <div className="prince_game_player">

                      <span className="prince_live_badge">

                        <span className="prince_live_icon"></span>

                        <span className="prince_live_text">
                          Live
                        </span>

                      </span>


                      <span className="prince_player_name">

                        {allgame?.Created_by?.Name?.slice(0, 5)}

                        {allgame?.Created_by?.Name?.length > 5 && "..."}

                      </span>

                    </div>


                    {/* =================================================
        AMOUNT INFORMATION
    ================================================== */}

                    <div className="prince_game_amount_box">

                      {/* ENTRY FEE */}

                      <div className="prince_game_amount">

                        <span className="prince_amount_label">
                          ENTRY FEE
                        </span>

                        <strong className="prince_entry_amount">
                          ₹{allgame?.Game_Ammount}
                        </strong>

                      </div>


                      {/* WINNING PRIZE */}

                      <div className="prince_game_amount">

                        <span className="prince_amount_label">
                          WINNING PRIZE
                        </span>

                        <strong className="prince_winning_amount">
                          ₹
                          {
                            allgame?.Game_Ammount +
                            winnAmount(allgame?.Game_Ammount)
                          }
                        </strong>

                      </div>

                    </div>

                  </div>


                  {/* =====================================================
      RIGHT ACTIONS
  ====================================================== */}

                  <div className="prince_game_action">


                    {/* =================================================
        PLAY
    ================================================== */}

                    {allgame.Status === "new" && (

                      <button
                        type="button"
                        className="prince_play_btn"
                        onClick={() =>
                          handleFakePlay(allgame)
                        }
                      >

                        <span className="prince_play_text">
                          PLAY
                        </span>

                        <span className="prince_play_arrow">
                          ▶
                        </span>

                      </button>

                    )}


                    {/* =================================================
        REQUESTED
    ================================================== */}

                    {allgame.Status === "requested" && (

                      <div className="prince_requested_wrap">

                        {/* REQUESTED */}

                        <button
                          type="button"
                          className="prince_play_btn prince_start_btn prince_requested_btn"
                        >

                          <span className="prince_play_text">
                            Requested
                          </span>

                        </button>


                        {/* CANCEL */}

                        <button
                          type="button"
                          className="prince_play_btn prince_start_btn prince_cancel_btn"
                          onClick={() =>
                            handleFakeCancel(allgame._id)
                          }
                        >

                          <span className="prince_play_text">
                            CANCEL
                          </span>

                        </button>

                      </div>

                    )}

                  </div>

                </div>

              ))

            }

            <div className="battle_divider"></div>
            <div className="mb-5">

              <div className="prince_open_battle_heading">

                <div className="prince_heading_side prince_heading_left">
                  <span></span>
                  <b>✦</b>
                  <span></span>
                </div>


                <div className="prince_open_battle_text">

                  <small>PRINCE LUDO</small>

                  <h2>
                    {translations[language].running}
                  </h2>

                </div>


                <div className="prince_heading_side prince_heading_right">

                  <span></span>
                  <b>✦</b>
                  <span></span>

                </div>

              </div>



              {MyrunningBattle &&
                MyrunningBattle.map((runnig) => {
                  if (
                    ((userId == runnig.Accepetd_By._id
                      ? (runnig.Status === "running" &&
                        userId == runnig.Accepetd_By._id &&
                        runnig.Acceptor_seen == true) ||
                      runnig.Status === "pending"
                      : (runnig.Status === "running" &&
                        userId == runnig.Created_by._id) ||
                      runnig.Status === "pending") ||
                      runnig.Status == "conflict") &&
                    (runnig?.Game_type == game_type ||
                      runnig?.Game_type == "ludoClassicManual" ||
                      runnig?.Game_type == "ludoClassicRich" || runnig?.Game_type == "LudoPopular")
                  )
                    return (
                      <RunningCard
                        key={runnig._id}
                        runnig={runnig}
                        user={users}
                        winnAmount={winnAmount}
                      />
                    );
                })}

              {OtherrunningBattle &&
                OtherrunningBattle.map((runnig) => {
                  if (
                    (userId == runnig?.Accepetd_By?._id ||
                      userId == runnig?.Created_by?._id
                      ? userId == runnig.Accepetd_By._id
                        ? (runnig.Status === "running" &&
                          userId == runnig.Accepetd_By._id &&
                          runnig.Acceptor_seen == true) ||
                        (runnig.Status === "pending" &&
                          runnig.Acceptor_status == null)
                        : (runnig.Status === "running" &&
                          user == runnig.Created_by._id) ||
                        (runnig.Status === "pending" &&
                          runnig.Creator_Status == null)
                      : runnig.Status === "running" ||
                      runnig.Status === "pending") &&
                    (runnig?.Game_type == game_type ||
                      game_type == "ludoClassicManual" ||
                      game_type == "ludoClassicRich")
                  )
                    return (
                      <>
                        <RunningCard
                          key={runnig._id}
                          runnig={runnig}
                          user={users}
                          winnAmount={winnAmount}
                        />
                      </>
                    );
                })}

              {/* running bor front se */}
              <FakeRunningBattle
                translations={translations}
                language={language}
                winnAmount={winnAmount}
              />

            </div>
          </div >
        </div >
      </div >

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}
